import { request } from './client'

export const getRaces = (opts = {}) => {
  const { published = true } = opts
  return request(`/races?published=${published}`)
}

export const getRace = slug => request(`/races/${encodeURIComponent(slug)}`)
